import { inject, Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { catchError, exhaustMap, map, of } from "rxjs";
import { SharedService } from "../../services/shared.service";
import { getCountryCulture, getUserProfile } from "../actions/shared.action";

@Injectable()

export class SharedEffects {
    private actions$ = inject(Actions);
    private sharedService = inject(SharedService);

    getUserProfile$ = createEffect(() =>
        this.actions$.pipe(
            ofType(getUserProfile.loadUserProfile),
            exhaustMap((action) => {
                if (action.status !== 'request') return of();
                return this.sharedService.getUserProfile().pipe(
                    map((data: any) => getUserProfile.loadUserProfile({ status: 'success', data })),
                    catchError((error) =>
                        of(getUserProfile.loadUserProfile({ status: 'failure', error }))
                    )
                )
            }

            )
        )
    );

    getCultureState$ = createEffect(() =>
        this.actions$.pipe(
            ofType(getCountryCulture.loadCountryCulture),
            exhaustMap((action) => {
                if (action.status !== 'request') return of();
                return this.sharedService.getCountryCulture().pipe(
                    map((data: any) => getCountryCulture.loadCountryCulture({ status: 'success', data })),
                    catchError((error) =>
                        of(getCountryCulture.loadCountryCulture({ status: 'failure', error }))
                    )
                )
            })
        )
    )

}

